import { generateClient } from 'aws-amplify/api';

export * from './types';
export * from './searchLimit';
export * from './constants';
export * from './fragments';
export * from './queries';

export const amplifyClient = generateClient();
